import React, { Fragment, Suspense } from 'react';
import find from 'lodash/find';
const AdapexSlot = React.lazy(() => import('./AdapexSlot'));
const GPTSlot = React.lazy(() => import('./GPTSlot'));
const AdapexOrGPTSlot = (props) => {
    const { appContext } = props;
    const { ad_units, ad_settings } = appContext.publisherClient || {};
    const hasAdapexDisplay = find(ad_units || [], { type: 'adapex_display' });
    if (!appContext.publisherClient) {
        return null;
    }
    return hasAdapexDisplay ? (<Suspense fallback={<Fragment />}>
      <AdapexSlot {...props}/>
    </Suspense>) : (<Suspense fallback={<Fragment />}>
      <GPTSlot refreshRate={ad_settings === null || ad_settings === void 0 ? void 0 : ad_settings.refresh_rate} {...props}/>
    </Suspense>);
};
export default AdapexOrGPTSlot;
